module.exports = __webpack_public_path__ + "img/blank.ce5237c4.svg";